import React from 'react';
import './FilePreviewModal.css';

const FilePreviewModal = ({ isOpen, onClose, fileUrl, fileName, onDownload }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="file-preview-modal" onClick={e => e.stopPropagation()}>
        <div className="preview-header">
          <div className="preview-header-left">
            <i className="bi bi-file-earmark-text preview-file-icon"></i>
            <h3 className="preview-title">{fileName || 'Vista previa'}</h3>
          </div>
          <div className="preview-header-actions">
            {onDownload && (
              <button 
                className="btn-preview-download" 
                onClick={onDownload}
                title="Descargar archivo"
              >
                <i className="bi bi-download"></i> Descargar
              </button>
            )}
            <button className="btn-preview-close" onClick={onClose} title="Cerrar">
              <i className="bi bi-x-lg"></i>
            </button>
          </div>
        </div>
        <div className="preview-body">
          {fileUrl ? (
            <iframe 
              src={fileUrl} 
              title="Vista previa del archivo"
              className="preview-iframe"
            />
          ) : (
            <div className="preview-loading">
              <div className="bouncing-loader">
                <div className="bounce-ball"></div>
                <div className="bounce-ball"></div>
                <div className="bounce-ball"></div>
              </div>
              <p className="preview-loading-text">Cargando vista previa...</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FilePreviewModal;
